"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promoTaskV1InfoSchema = void 0;
const zod_1 = require("zod");
const __1 = require("../..");
exports.promoTaskV1InfoSchema = zod_1.z.object({
    promotionId: zod_1.z.string().uuid(),
    promotionType: zod_1.z.nativeEnum(__1.PromotionType),
});
//# sourceMappingURL=promotion.task.js.map